<template>
  <div :class="cssClass.wrapper">
    <v-file-input
      :prepend-inner-icon="getPrependedInnerIcon"
      :prepend-icon="getPrependedIcon"
      :disabled="getIrisRdonlyMode || $attrs.disabled"
      :filled="getIrisRdonlyMode || $attrs.filled"
      v-on="$listeners"
      :label="$attrs.label"
      :rules="rules"
      :show-size="true"
      :accept="acceptFormat"
      :value="value instanceof Object && value.size > 0 ? value : undefined"
      @change="selectFile($event)"
      @click:clear="image = null"
      ref="fileUpload"
      v-bind="$attrs"
      :append-icon="getAppendedIcon"
      :class="[getIrisCssClass,cssClass.input]"
      truncate-length="99"
    >
      <template v-slot:selection="{ text }">
        {{ getFileValue(text) }}
      </template>
      <template v-slot:label v-if="$attrs.required && !this.$attrs.rdonly"> {{ $attrs.label }} <span class="red--text">*</span> </template>
      <template v-slot:append-outer><slot name="edn-append-outer"></slot></template>
    </v-file-input>
  </div>
</template>

<script>
import { ednRequired } from './mixins/ednRequired'
import { ednRegex } from './mixins/ednRegex'
import { ednMimicMix } from './mixins/ednMimicMix'

export default {
  inheritAttrs: false,
  mixins: [ednRequired, ednMimicMix,ednRegex],
  props: {
    value: null,
    errorMsg: {
      type: String,
      default: () => '',
    },
    validateRes: {
      type: String,
      default: () => 'Valider',
    },
    acceptFormat: {
      type: String,
      default: '',
    },
    labelUploadImage: {
      type: String,
      default: '',
    },
    /**
     * Affiche des valeurs personnalisés à la place des valeurs de l'object File
     */
    customValues: {
      type: Object,
      default: () => null,
    },
    // Classes CSS par le parent si définies
    cssClass: {
      type: Object,
      default: () => { return {input:'',button:''}},
    },
    //Taille max du fichier
    imgSize: {
      type:Number,
      default: ()=> null   
    }
  },
  data() {
    return {
      image: {},
      content: this.value,
      hasChanged: false,
      cachedFile: undefined,
      cachedText: this.cachedFile
        ? this.$refs.fileUpload.$el.children[1].children[0].children[0].children[1].innerText
        : '',
    }
  },
  watch: {
    content() {
      this.$emit('input', this.content)
    },
    value() {
      if (this.value !== this.content) {
        this.content = this.value
      }
      if (this.value instanceof Object) {
        this.convertToBlob(this.value)
      }
    },
  },
  methods: {
    selectFile(file) {
      // on vérifie que le fichier a changé pour éviter un $emit inutile car la méthode est appelée à l'event change
      if (file && this.content != file) {
        this.content = file
        //envoie la valeur au parent
        if(this.content.size <= this.imgSize || this.imgSize == null) this.$emit('uploadFile', this.content)
        else this.$emit('emptyImgFile', this.content)

        this.hasChanged = true
        this.$emit('hasChanged', this.hasChanged)
      } else if( !file ) {
        this.$emit('update:file', undefined);
      } else {
        if (this.content === this.cachedFile) {
          this.content = this.cachedFile
        }
      }
    },
    convertToBlob(img) {
      if (img && img.size) {
        try {
          const reader = new FileReader()
          reader.readAsDataURL(img)
          reader.onload = (e) => {
            this.image = e.target.result
            this.$emit('getImage', this.image)
          }
        } catch (error) {
          console.error(error)
        }
      }
    },
    /**
     * Affiche la valeur du champs : si c'est en chargement, on n'affiche rien, si on a des valeurs personnalisées ( nom et taille), on affiche ces dernières
     * Sinon on affiche ce que nous renvoie l'objet File ( conversion Byte en octet)
     */
    getFileValue(text) {
      return this.$attrs.loading 
        ? '':
        !(this.customValues && this.customValues.name)
        ? text.split('(')[0] + text.slice(text.indexOf('(')).replace('B', 'o')
        : `${this.customValues.name} (${this.customValues.size})`
    },
  },
  computed: {
    /**
     * Si on est en mimic et readonly, on n'affiche pas l'icône paper-clip là ($file est
     * l'icône par défaut de la props )
     */
    getPrependedInnerIcon() {
      if (!this.getIrisRdonlyMode) return ''
      else return 'mdi-paperclip'
    },
    getPrependedIcon() {
      if (!this.getIrisRdonlyMode) return '$file'
      else return ''
    },
  },
  mounted() {
    if (typeof this.content === 'object') {
      this.convertToBlob(this.content)
    }
    if(this.imgSize != null){
      let maxSize = this.$vuetify.lang.t('$vuetify.maxSize').replace('[SIZE]', this.imgSize/1000000)
      this.rules.push((value) => !value || value.size < this.imgSize 
      || maxSize)
    }
  },
}
</script>

<style lang="scss" scoped></style>
